import React, { useState, useEffect, useMemo, use } from "react";
import { useTranslation } from "react-i18next";
import { Drawer, Typography } from "antd";
import { Header, Banner, Button } from "@/components";
import { Empty } from "@/components/dc-banner";
import { useStores } from "@/store";
import { ReviewItem, ReviewDetail } from "./Reviews";
import { Chef } from "./Chef";

const { Paragraph } = Typography;

const toLow = (str) => {
  return String(str).toLowerCase();
};

/**菜单 */
export const Menus = ({ menus, chef, track }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [course, setCourse] = useState(null);
  function onClick(course) {
    setVisible(true);
    track && track(course)
    setCourse(course || {});
  }

  return (
    <section className="page-restaurant--menu">
      {chef && <Chef chef={chef} />}
      <div className="menu-wrapper">
        {menus.map((item) => {
          return <MenuItem menu={item} key={item.id} onClick={onClick} />;
        })}
      </div>
      <Drawer
        className="restaurant-drawer"
        placement="right"
        closable={false}
        destroyOnClose
        onClose={() => setVisible(false)}
        visible={visible}
      >
        {course && <CourseDetails course={course} setVisible={setVisible} />}
      </Drawer>
    </section>
  );
};

const CourseDetails = ({ course, setVisible }) => {
  const { t } = useTranslation();
  const { restaurantStore } = useStores();
  const [photos, setPhotos] = useState([]);
  const { name, desc, tags = [], source_id, id } = course || {};
  const { comments_count = 0, photos_count = 0 } = course.menu || {};
  useEffect(() => {
    if (photos_count > 0) {
      restaurantStore.getMenuPhotos(id).then(setPhotos);
    } else {
      setPhotos([]);
    }
  }, []);
  return (
    <div className="course-details">
      <Header title={t("WEB.Dish details")} onClick={() => setVisible(false)} />
      <div className="menu-dish--photos">
        {photos.length ? <Banner photos={photos} /> : <Empty />}
      </div>
      <div className="menu-dish--profile">
        <h3>{name}</h3>
        <p>{desc}</p>
        <CourseTags tags={tags || []} />
      </div>
      <div className="menu-dish--reviews" >
        <ReviewList count={comments_count} id={id} />
      </div>
    </div>
  );
};

/**评分&评论 */
const ReviewList = ({ id }) => {
  const { t } = useTranslation();
  const [visible2, setVisible2] = useState(false);
  const [list, setList] = useState([]);
  const [currentReview, setCurrentReview] = useState({});
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { restaurantStore } = useStores();
  const showMore = useMemo(() => {
    return count > 20 && list.length < count;
  }, [count, list]);

  useEffect(() => {
    setPage(1);
    onLoadMore();
  }, [id]);

  useEffect(() => {
    if (page > 1) {
      onLoadMore();
    }
  }, [page]);

  /**加载更多 */
  async function onLoadMore() {
    setLoading(true);
    try {
      let data = await restaurantStore.getReviews(page, id);
      let newList = [];
      if (page > 1) {
        newList = list.concat(data);
      } else {
        newList = data;
      }
      setLoading(false);
      setList(newList);
      setCount(data.headers?.total_count);
    } catch (error) {
      setLoading(false);
    }
  }

  /**查看详情 */
  function onShow(item) {
    setCurrentReview(item);
    setVisible2(true);
  }

  /**查看大图 */
  function onPreview() {}

  return (
    <section className="page-restaurant--reviews">
      {
        count > 0 && <h3>{t("WEB.Reviews", { count: count })}</h3>
      }

      {/* 详情 */}
      <ReviewDetail
        review={currentReview}
        onPreview={onPreview}
        visible={visible2}
        setVisible={setVisible2}
      />

      {/* 列表 */}
      {list.map((item) => {
        return (
          <ReviewItem
            key={item.id}
            review={item}
            mobile={true}
            onPreview={onPreview}
            onClick={() => onShow(item)}
          />
        );
      })}
      <div className="show-load">
        {showMore && (
          <Button
            type="primary"
            block
            onClick={() => setPage(page + 1)}
            loading={loading}
          >
            {t("WEB.Show more reviews")}
          </Button>
        )}
      </div>
    </section>
  );
};

const Line = () => {
  return (
    <div
      className="hairline-bottom"
      style={{ height: 10, marginBottom: 10 }}
    ></div>
  );
};

const MenuItem = ({ menu, onClick }) => {
  const { t } = useTranslation();
  const { extras_menu = {}, menu_title, terms_conditions, id, desc } =
    menu || {};
  const { vat_text, service_fee_text, desc: menu_desc } = extras_menu || {};
  const courses = useMemo(() => {
    return extras_menu.course_groups || [];
  }, []);
  const show_seats_multiplier = !!menu.seats_multiplier_humanize
  return (
    <div className="menu-item" id={"menu-item-" + id}>
      <div className="menu-item--head">
        <div className="menu-item--title">
          <strong>{menu_title}</strong>
          <span>{desc}</span>
        </div>
        <div className="menu-item--seats">
          <div className="menu-item--seats-item">
            <img src={require('../../../images/seat2_red.svg')} width="16" height="16" alt="" />
            <span>{ menu.minimum_seats_humanize }</span>
          </div>
          <div className="menu-item--seats-item">
            {
              show_seats_multiplier && <img src={require('../../../images/seat_red.svg')} width="16" height="16"  alt="" />
            }
            <span>{ menu.seats_multiplier_humanize }</span>
          </div>
        </div>
        <div
          hidden={!menu_desc}
          className="menu-item--desc"
          dangerouslySetInnerHTML={{ __html: menu_desc }}
        ></div>
        <div
          hidden={!terms_conditions}
          className="menu-item--desc"
          dangerouslySetInnerHTML={{ __html: terms_conditions }}
        ></div>
      </div>
      <div className="menu-item--courses">
        {courses.map((item, index) => {
          return <CourseItem course={item} key={index} onClick={onClick} />;
        })}
      </div>
      <div className="menu-item--desc" hidden={!vat_text}>
        {vat_text}
      </div>
      <div className="menu-item--desc" hidden={!service_fee_text}>
        {service_fee_text}
      </div>
    </div>
  );
};

const CourseItem = ({ course, onClick }) => {
  const { subs = [], name = "" } = course || {};
  function count(data, name) {
    try {
      let count = data.menu[name];
      return count;
    } catch (error) {
      return 0;
    }
  }

  // 隐藏箭头
  function hideArrow(sub) {
    return (
      count(sub, "photos_count") < 1 &&
      count(sub, "comments_count") < 1 &&
      !sub.desc
    );
  }
  return (
    <div className="course-item">
      <div className="course-item--title">{name}</div>
      {subs.map((sub, index) => {
        return (
          <div key={index} onClick={() => onClick(sub)}>
            <div className="course-item--desc">
              <span className="course-item--desc-title">
                <Paragraph ellipsis={{ rows: 2 }}>
                  {sub.name}
                </Paragraph>
              </span>
              <span className="course-item--desc-action">
                <i
                  className="course-action icon icon-image"
                  hidden={count(sub, "photos_count") < 1}
                ></i>
                <i
                  className="course-action icon icon-review-grey"
                  hidden={count(sub, "comments_count") < 1}
                ></i>
                <i
                  className="icon icon-arrow-right"
                  hidden={hideArrow(sub)}
                ></i>
              </span>
            </div>
            <Paragraph className="course-item--subdesc" ellipsis={{ rows: 2 }}>
              {sub.desc}
            </Paragraph>
            <CourseTags tags={sub.tags || []} />
            <div
              className="course-item--separator"
              hidden={index >= subs.length - 1}
            >
              <i>
                <span className="small">{toLow(sub.separator)}</span>
              </i>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const CourseTags = ({ tags }) => {
  return (
    <div className="course-tags">
      {tags.map((tag, index) => {
        return (
          <span className="course-item--tag" key={tag.id}>
            <i
              style={{
                backgroundImage: `url(${tag.icon_url})`,
              }}
            ></i>
            {tag.name}
            <span hidden={index >= tags.length - 1}></span>
          </span>
        );
      })}
    </div>
  );
};
